export const GOOGLE_GEMINI_SERVICE_TIERS_V816 = Object.freeze([
  'standard',
  'flex',
  'priority',
]);

export const VERTEX_PROVIDER_SERVICE_TIERS_V817 = Object.freeze([
  'standard',
  'flex',
  'express',
  'priority',
]);

export const VERTEX_OPENAI_COMPATIBLE_SERVICE_TIERS_V817 = Object.freeze([
  'standard',
  'flex',
]);

export const VOYCLOUD_OPENAI_COMPATIBLE_SERVICE_TIERS_V820 = Object.freeze([
  'standard',
  'flex',
  'batch',
]);

export const OPENAI_COMPATIBLE_PROFILES_V820 = Object.freeze([
  '',
  'voycloud',
  'openlux',
]);

export const buildGoogleGeminiServiceTierOptionsV816 = (t) =>
  GOOGLE_GEMINI_SERVICE_TIERS_V816.map((tier) => ({
    key: tier,
    value: tier,
    text: t(`channel.edit.google_gemini_service_tier_${tier}_v816`),
  }));

export const buildVertexProviderServiceTierOptionsV817 = (t) =>
  VERTEX_PROVIDER_SERVICE_TIERS_V817.map((tier) => ({
    key: tier,
    value: tier,
    text: t(`channel.edit.vertex_provider_service_tier_${tier}_v817`),
  }));

export const buildVertexOpenAICompatibleServiceTierOptionsV817 = (
  t,
  profile = ''
) =>
  (profile === 'voycloud'
    ? VOYCLOUD_OPENAI_COMPATIBLE_SERVICE_TIERS_V820
    : VERTEX_OPENAI_COMPATIBLE_SERVICE_TIERS_V817
  ).map((tier) => ({
    key: tier,
    value: tier,
    text: t(`channel.edit.vertex_provider_service_tier_${tier}_v817`),
  }));

export const buildOpenAICompatibleProfileOptionsV820 = (t) =>
  OPENAI_COMPATIBLE_PROFILES_V820.map((profile) => ({
    key: profile || 'generic',
    value: profile,
    text:
      profile === 'openlux'
        ? 'OpenLux'
        : t(
            `channel.edit.vertex_openai_compatible_profile_${
              profile || 'generic'
            }_v820`
          ),
  }));

export const isOpenAICompatibleVertexGroupV817 = (
  channelType,
  channelGroups
) => {
  const groups = (
    Array.isArray(channelGroups)
      ? channelGroups
      : String(channelGroups || '').split(',')
  )
    .map((group) =>
      String(group || '')
        .trim()
        .toLowerCase()
    )
    .filter(Boolean);
  return (
    Number(channelType) === 50 && groups.length === 1 && groups[0] === 'vertex'
  );
};

export const normalizeVertexOpenAICompatibleConfigV817 = (
  channelType,
  channelGroups,
  config = {}
) => {
  if (!usesCompatibleServiceTierV1015(channelType, channelGroups, config)) {
    return { ...config };
  }
  const tier = String(config.vertex_ai_service_tier || '')
    .trim()
    .toLowerCase();
  const requestedProfile = String(config.openai_compatible_profile || '')
    .trim()
    .toLowerCase();
  const profile = OPENAI_COMPATIBLE_PROFILES_V820.includes(requestedProfile)
    ? requestedProfile
    : '';
  const allowedTiers =
    profile === 'voycloud'
      ? VOYCLOUD_OPENAI_COMPATIBLE_SERVICE_TIERS_V820
      : VERTEX_OPENAI_COMPATIBLE_SERVICE_TIERS_V817;
  return {
    ...config,
    openai_compatible_profile: profile,
    vertex_ai_service_tier: allowedTiers.includes(tier) ? tier : 'standard',
  };
};

export const isVoycloudProfileV1015 = (channelType, config = {}) =>
  Number(channelType) === 50 &&
  String(config.openai_compatible_profile || '')
    .trim()
    .toLowerCase() === 'voycloud';

export const usesCompatibleServiceTierV1015 = (
  channelType,
  groups,
  config = {}
) =>
  config.openai_compatible_profile !== 'openlux' &&
  (isVoycloudProfileV1015(channelType, config) ||
    isOpenAICompatibleVertexGroupV817(channelType, groups));

export const normalizeGoogleGeminiConfigV816 = (channelType, config = {}) => {
  const numericType = Number(channelType);
  if (numericType === 42) {
    const tier = String(config.vertex_ai_service_tier || '')
      .trim()
      .toLowerCase();
    return {
      ...config,
      vertex_ai_service_tier: VERTEX_PROVIDER_SERVICE_TIERS_V817.includes(tier)
        ? tier
        : 'standard',
    };
  }
  if (![24, 53].includes(numericType)) {
    return { ...config };
  }
  const tier = String(config.vertex_ai_service_tier || '')
    .trim()
    .toLowerCase();
  return {
    ...config,
    vertex_ai_service_tier: GOOGLE_GEMINI_SERVICE_TIERS_V816.includes(tier)
      ? tier
      : 'standard',
  };
};
